import React from "react";
import { Route, Redirect } from "react-router-dom";
import Admin from "../layout/Admin.js";
import localOrSessionStore from "_helpers/localOrSessionStore";
import variables from "_constants/variables";

const PrivateRoute = ({component: Component, ...rest}) => {
    return (

        // Show the component only when the user is logged in
        // Otherwise, redirect the user to /signin page
        <Route {...rest} render={props => {


            const storage = localOrSessionStore({ key: variables.REMEMBER });
            var token = (storage.getItem(variables.TOKEN));

            if (!token) {
                return (
                    <Redirect to={{ pathname: "/auth/login", state: { from: props.location } }} />
                );
            }
            return <Admin {...props} />;
        }} />
    );
};

export default PrivateRoute;

